<template>
  <div id="q-app">
    <router-view />

    <!-- 🔥 Global chatbot -->
    <!-- <ChatbotIframe :user="user" /> -->
  </div>
</template>

<script>
// import ChatbotIframe from "src/components/ChatbotIframe.vue";
import $api from "src/services/api";

export default {
  name: "App",

  // components: { ChatbotIframe },

  data() {
    return {
      user: null,
      lastTokenId: null
    };
  },

  created() {
    // API might emit this if the request fails.
    this.$api.on("disconnected", () => {
      this.$router
        .push(this.$router.currentRoute.path + "/disconnected")
        .catch(() => {});
    });
    console.log("[App.vue] created");
    this.resolveAuthForChatbot();
  },

  watch: {
    // Re-run when route changes
    "$route.fullPath"() {
      this.resolveAuthForChatbot();
    }
  },

  //   watch: {
  //   "$route.params.token_id": {
  //     immediate: true,
  //     handler() {
  //       this.resolveAuthForChatbot();
  //     }
  //   }
  // }

  methods: {
    /**
     * Fetch user ONLY for chatbot iframe
     * Does NOT touch Vuex
     */
    async resolveAuthForChatbot() {
      const tokenId = this.$route.params.token_id || null;

      // Prevent duplicate calls
      if (tokenId === this.lastTokenId) return;
      this.lastTokenId = tokenId;

      // 🔴 VISITOR
      if (!tokenId) {
        console.log("[ChatbotAuth] visitor");
        this.user = null;
        this.lastTokenId = null; // 🔥 RESET
        return;
      }

      // 🔵 FETCH USER ONLY FOR CHATBOT
      try {
        console.log("[ChatbotAuth] fetching user for chatbot");

        const res = await $api.links.get(tokenId);
        console.log("res in app", res);
        // Extract ONLY what chatbot needs
        this.user = {
          _id: res?.user_info._id,
          email: res?.user_info.email,
          fname: res?.user_info.fname,
          lname: res?.user_info.lname
        };

        console.log("[ChatbotAuth] chatbot user resolved", this.user);
      } catch (err) {
        console.error("[ChatbotAuth] failed → visitor", err);
        this.user = null;
      }
    }
  }
};
</script>

<style lang="scss">
#q-app {
  font-family: "Nunito", sans-serif;
  font-size: 0.875rem;
  @media (min-width: $breakpoint-sm-min) {
    font-size: 1rem;
  }
  font-weight: 300;
}
</style>
